<app-toast></app-toast>
<app-onboarding-video-call></app-onboarding-video-call>
<app-video-call></app-video-call>
<router-outlet></router-outlet>
